import { createAndDownloadExcel } from './excelExportUtils';

/**
 * Log verilerini Excel formatında indirir
 *
 * @param {Array} rows - DataGrid satırları
 * @param {Array} columns - DataGrid kolonları
 * @param {string} nodeName - Node adı
 */
export const exportLogs = (rows, columns, nodeName = 'Node') => {
  // Epoch'u tarih formatına çeviren transformer
  const valueTransformer = (value, column) => {
    if (column.field === 'epoch' && value) {
      return new Date(value).toLocaleString();
    }
    return value;
  };

  // Satırları epoch'a göre sıralayan fonksiyon
  const rowSorter = (a, b) => {
    return new Date(a.epoch) - new Date(b.epoch);
  };

  const now = new Date();
  const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const timeStr = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}`;
  const fileName = `${nodeName}_${dateStr}_${timeStr}_Loglar.xlsx`;

  return createAndDownloadExcel(
    rows,
    columns,
    'Loglar',
    fileName,
    {
      valueTransformer,
      rowSorter,
      maxColumnWidth: 80 // message için daha geniş
    }
  );
};
